// ================================
// 🔠 FORMATTERS
// ================================

// ✅ Proper Case (DEFAULT)
export const toProperCase = (str) => {
  if (!str || typeof str !== "string") return str;

  return str
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

// 🔠 Sentence Case
export const toSentenceCase = (str) => {
  if (!str || typeof str !== "string") return str;

  const lower = str.toLowerCase();
  return lower.charAt(0).toUpperCase() + lower.slice(1);
};

// ================================
// ❌ KEYS TO SKIP (NO FORMAT)
// ================================
const DEFAULT_SKIP_KEYS = [
  "EmailId",
  "GSTNo",
  "GSTIN",
  "PanNo",
  "PAN",
  "TANNo",
  "MobileNo",
  "GroupCode",
  "ItemCode",
  "SONumber",
  "RefNo",
  "ChallanNumber",
  "PONumber",
  "BillNumber",
  "UserName",
  "CurrencyName"
];

// ================================
// 🧩 MAIN ROW FORMATTER
// ================================
export const formatRows = (rows = [], options = {}) => {
  const {
    skipKeys = DEFAULT_SKIP_KEYS,
    formatter = toProperCase,              // ⭐ DEFAULT FORMATTER
    columnFormatters = {},                 // ⭐ COLUMN-WISE OVERRIDE
  } = options;

  return rows.map((row) => {
    const formattedRow = {};

    Object.entries(row).forEach(([key, value]) => {
      // ❌ Skip exact keys
      if (skipKeys.includes(key)) {
        formattedRow[key] = value;
        return;
      }

      // 🔠 Only format strings
      if (typeof value !== "string") {
        formattedRow[key] = value;
        return;
      }

      // ⭐ Column-specific formatter wins
      if (columnFormatters[key]) {
        formattedRow[key] = columnFormatters[key](value);
      } else {
        // ⭐ Default formatter
        formattedRow[key] = formatter(value);
      }
    });

    return formattedRow;
  });
};
